var $a118670bf7476f3e$exports = {};
const $a118670bf7476f3e$var$createPromiseGate = ()=>{
    const ext = {};
    const promise = new Promise((resolve, reject)=>{
        ext.resolve = resolve;
        ext.reject = reject;
    });
    Object.assign(promise, ext);
    return promise;
};
$a118670bf7476f3e$exports = $a118670bf7476f3e$var$createPromiseGate;


export {$a118670bf7476f3e$exports as default};
//# sourceMappingURL=module.js.map
